import { html } from 'lit/html.js'
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

// Icons
import icon from 'url:./icon.svg'
import copyIcon from 'url:view-base/type-icon/copy.svg'

import { uri } from '../data-util'
import langs from './language.json'
import * as immu from 'object-path-immutable'
import 'view-base/unit-button'
import 'view-base/unit-link'
import { textTable } from './textTable'
import { provider } from './provider'
import * as util from '../view-advice-util'

// ----------------------------------------------
// Creator of text for view adivce and params
// drugs, rules, faqs come as ObjectById
// ----------------------------------------------
export function text( xeon ) {

  // Ensure language and enable manual override
  const lang = uri.lang()
  const dict = langs[ lang ]
  const data = provider( xeon )

  // -------------------------------
  // Collect tools for scenarios
  // -------------------------------
  const da = data.danger()
  // Answers - { yes:[], no: ["kognitiv.tremor"], unknown: [], missing: [] }
  const as = data.answers()
  // Drugs with id to translated name
  const ns = data.drugNamesById( lang )
  // Group drugs according to effect strength
  const sg = data.subgroup()
  // Make drugs bold
  const rd = util.replaceDrugs( dict.place1, dict.place2, lang )
  // Collect htmls for scenarios as strings
  const empfehlung = []
  const bewertung = []
  // Collect fragments
  const htmls = []

  // ---------------------------
  // Case: no wirkstoff abort
  // ---------------------------
  if ( Object.values( xeon.drugs ).length == 0 ) {
    htmls.push( html `
      <h2>
        <img src="${icon}" alt="${dict.alt}"/>
        <span>${dict.title}</span>
        <span style="flex:1"></span>
      </h2>
      <p style="margin-top:1.5rem;">${dict.nowirkstoff}</p>
    ` )
    return html `<div class="box anticholinergic">${htmls}</div>`
  }

  // ---------------------------------------------------------------------
  // 1. Scenario - Drugs of little danger
  // http://localhost:5002/clinic/advice/de/?s=citalopram/
  // http://localhost:5002/clinic/advice/de/?s=rizatriptan,sumatriptan/
  // --------------------------------------------------------------------
  // Be careful
  if ( da > 0 && da < 3 ) {
    if ( sg.mild.length > 0 ) {
      bewertung.push( rd( sg.mild.map( id => ns[ id ] ), dict.scene1a1, dict.scene1a2 ) )
    }
    if ( sg.moderate.length > 0 ) {
      bewertung.push( rd( sg.moderate.map( id => ns[ id ] ), dict.scene1b1 ) )
    }
    bewertung.push( dict.scene1c )
    empfehlung.push( dict.scene1d )
  }

  // ---------------------------------------------------------
  // 2. Scenario - Drugs of danger
  // ---------------------------------------------------------
  if ( da >= 3 ) {

    const antidrugs = [ ...sg.strong, ...sg.moderate, ...sg.mild ].map( id => ns[ id ] )

    if ( antidrugs.length == 1 ) {
      bewertung.push( rd( antidrugs[ 0 ], dict[ "scene2a1" ] ) )
      empfehlung.push( dict.scene1d )
    } else {
      const names = []
      names.push( ...sg.strong.map( id => `<b class=d>${ns[id]}</b> (<b class=r>${dict["scene2sto"]}</b>)` ) )
      names.push( ...sg.moderate.map( id => `<b class=d>${ns[id]}</b> (${dict["scene2mod"]})` ) )
      names.push( ...sg.mild.map( id => `<b class=d>${ns[id]}</b> (${dict["scene2mil"]})` ) )
      const text = rd( names, dict[ "scene2a2" ], dict[ "scene2a2" ] )
      bewertung.push( util.capitalize( text ) )
      empfehlung.push( dict[ "scene2emp1" ] )
      empfehlung.push( dict[ "scene2emp2" ] )
    }

  }


  // ----------------------------------------------------------------------
  // 4a. Scenario - show drugs in any scenario even if not anticholinergic
  // http://localhost:5002/clinic/advice/de/for-drug-simvastatin/
  // http://localhost:5002/clinic/advice/de/for-drug-simvastatin-alfuzosin/
  // ---------------------------------------------------------------------
  if ( sg.none.length > 0 ) {
    // Array of drug ids
    const nonedrugs = sg.none.map( id => ns[ id ] )
    bewertung.push( rd( nonedrugs, dict.scene4a1, dict.scene4a2 ) )
  }

  // 4b. None and / o
  if ( sg.insignificant.length > 0 ) {
    // Array of drug ids
    const nonedrugs = sg.insignificant.map( id => ns[ id ] )
    bewertung.push( rd( nonedrugs, dict.scene4b1, dict.scene4b2 ) )
  }

  // --------------------------------------------------
  // Finalize rendering and join will create space
  // between sentences
  // --------------------------------------------------
  // Header with magnifying blue vesicles
  htmls.push( html `
    <h2>
      <img src="${icon}" alt="${dict.alt}"/>
      <span>${dict.title}</span>
      ${ util.build.up("abridge") }
      <span style="flex:1"></span>
      ${ util.build.hub(`docs/anticholinergic/${lang}`) }
      <span class=bar></span>
      ${ util.build.copy("anticholinergic") }
      <span class=bar></span>
      <span class=score>-${ data.score() }%</span>
    </h2>
  ` )
  // Add table
  htmls.push( html `
    <section class=wide>${textTable(xeon)}</section>
  ` )
  // One Chapter
  if ( empfehlung.length ) {
    htmls.push( html `
      <p>
        <span class="chapter">${dict.empfehlung}: </span>
        <span class=over>${unsafeHTML(empfehlung.join(" "))}</span>
      </p>
    ` )
  }
  // One Chapter
  if ( bewertung.length ) {
    htmls.push( html `
      <p>
        <span class="chapter">${dict.bewertung}: </span>
        <span>${unsafeHTML(bewertung.join(" "))}</span>
      </p>
    ` )
  }

  return html `<div class="box anticholinergic">${htmls}</div>`

}